import { Icon, UserGeneratedHtml } from "@trueskin-web/components"
import { checkCircleIcon } from "@trueskin-web/theme/icons/checkCircleIcon"
import { crossCircleIcon } from "@trueskin-web/theme/icons/crossCircleIcon"

const PlanDetails = ({ details, checkIcon }) => {
  return (
    <ul sx={{ mt: 4, p: 0 }}>
      {details.map(({ content, icon }, index) => (
        <li
          key={index}
          sx={{
            mb: [2, 4],
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
            fontSize: [1, 2],
          }}
        >
          {checkIcon ? (
            checkIcon
          ) : (
            <Icon
              icon={icon === "cross" ? crossCircleIcon : checkCircleIcon}
              size="sm"
              sx={{
                color: icon === "cross" ? "rose" : "primary",
                position: "relative",
                top: ["0.19em", "0.23em"],
              }}
            />
          )}
          <UserGeneratedHtml html={content} />
        </li>
      ))}
    </ul>
  )
}

export default PlanDetails
